import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';
import { customerStatuses } from '../../utils/constants/tagColors';

const useColumns = () => {
  const { t } = useTranslation();

  return [
    {
      title: t('customers.form.status'),
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={customerStatuses[status || 'PROSPECT']}>
          {t(`customers.tags.${status || 'PROSPECT'}`)}
        </Tag>
      ),
      sorter: true
    },
    {
      title: t('customers.form.first_name'),
      dataIndex: 'first_name',
      key: 'first_name',
      sorter: true
    },
    {
      title: t('customers.form.last_name'),
      dataIndex: 'last_name',
      key: 'last_name',
      sorter: true
    },
    {
      title: t('customers.form.email'),
      dataIndex: 'email',
      render: (email) => (
        <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
          {email}
        </a>
      ),
      key: 'email',
      sorter: true
    },
    {
      title: t('customers.form.phone_number'),
      dataIndex: 'phone_number',
      render: (phone_number) => (
        <a href={`tel:${phone_number}`} style={{ fontWeight: 'bold' }}>
          {phone_number}
        </a>
      ),
      key: 'phone_number',
      sorter: true
    }
  ];
};

export default useColumns;
